(function () {
  'use strict';

  var GSAP_JS = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var GSAP_ST = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.getAttribute('data-loaded') === 'true') return resolve();
        existing.addEventListener('load', function () { resolve(); });
        existing.addEventListener('error', reject);
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = function () {
        script.setAttribute('data-loaded', 'true');
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function loadGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    return loadScript(GSAP_JS).then(function () {
      return loadScript(GSAP_ST);
    });
  }

  function initReveals(root, gsap, ScrollTrigger) {
    var items = root.querySelectorAll('[data-reveal]');
    items.forEach(function (el, i) {
      ScrollTrigger.create({
        trigger: el,
        start: 'top 88%',
        onEnter: function () {
          el.classList.add('is-in');
        },
        once: true
      });
    });
  }

  function initStats(root, gsap, ScrollTrigger) {
    var stats = root.querySelectorAll('[data-stat-value]');
    stats.forEach(function (el) {
      var raw = el.getAttribute('data-stat-value');
      var num = parseFloat(raw);
      if (isNaN(num)) return;
      var decimals = (raw.split('.')[1] || '').length;
      var counter = { val: 0 };
      ScrollTrigger.create({
        trigger: el,
        start: 'top 90%',
        once: true,
        onEnter: function () {
          gsap.to(counter, {
            val: num,
            duration: 1.4,
            ease: 'power2.out',
            onUpdate: function () {
              el.textContent = counter.val.toFixed(decimals);
            }
          });
        }
      });
    });
  }

  function initHeroParallax(root, gsap, ScrollTrigger) {
    var hero = root.querySelector('[data-indulge-hero]');
    if (!hero) return;
    var layers = hero.querySelectorAll('[data-parallax-layer]');
    if (!layers.length) return;
    layers.forEach(function (layer) {
      var speed = parseFloat(layer.getAttribute('data-speed') || '0.15');
      gsap.to(layer, {
        yPercent: speed * 100,
        ease: 'none',
        scrollTrigger: {
          trigger: hero,
          start: 'top top',
          end: 'bottom top',
          scrub: true
        }
      });
    });
    gsap.to(hero.querySelector('.indulge__hero-glow'), {
      opacity: 0.4,
      ease: 'none',
      scrollTrigger: {
        trigger: hero,
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }
    });
  }

  function initSpin(root, gsap, ScrollTrigger) {
    var canvas = root.querySelector('[data-spin-canvas]');
    if (!canvas) return;
    var frameCount = parseInt(canvas.getAttribute('data-frame-count'), 10) || 0;
    if (frameCount < 2) return;
    var sample = canvas.getAttribute('data-frame-sample');
    var token = canvas.getAttribute('data-frame-token') || '001';
    if (!sample) return;
    var pad = token.length;
    var ctx = canvas.getContext('2d');
    var images = new Array(frameCount);
    var loaded = 0;
    var ready = false;
    var current = { frame: 0 };

    function frameSrc(i) {
      var n = String(i + 1).padStart(pad, '0');
      return sample.replace(token + '.jpg', n + '.jpg');
    }

    function draw(i) {
      var img = images[i];
      if (!img || !img.complete || !img.naturalWidth) return;
      var ratio = Math.min(canvas.width / img.naturalWidth, canvas.height / img.naturalHeight);
      var w = img.naturalWidth * ratio;
      var h = img.naturalHeight * ratio;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, (canvas.width - w) / 2, (canvas.height - h) / 2, w, h);
    }

    function resize() {
      var rect = canvas.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
      if (ready) draw(Math.round(current.frame));
    }

    var first = new Image();
    first.src = frameSrc(0);
    first.onload = function () {
      images[0] = first;
      resize();
      draw(0);
      for (var i = 1; i < frameCount; i++) {
        (function (idx) {
          var img = new Image();
          img.src = frameSrc(idx);
          img.onload = function () {
            loaded++;
            if (loaded === frameCount - 1) ready = true;
          };
          images[idx] = img;
        })(i);
      }
    };

    window.addEventListener('resize', resize);

    gsap.to(current, {
      frame: frameCount - 1,
      ease: 'none',
      scrollTrigger: {
        trigger: canvas.closest('[data-indulge-hero]') || canvas,
        start: 'top top',
        end: 'bottom top',
        scrub: 0.4,
        onUpdate: function () {
          draw(Math.round(current.frame));
        }
      }
    });
  }

  function initUnbox(root, gsap, ScrollTrigger) {
    var stage = root.querySelector('[data-unbox-stage]');
    if (!stage) return;
    var lid = stage.querySelector('[data-unbox-lid]');
    if (!lid) return;
    gsap.timeline({
      scrollTrigger: {
        trigger: stage,
        start: 'top 75%',
        end: 'bottom 40%',
        scrub: 0.6
      }
    }).to(lid, {
      yPercent: -18,
      rotateX: 35,
      opacity: 0,
      ease: 'none'
    });

    var items = root.querySelectorAll('[data-unbox-item]');
    if (items.length) {
      gsap.to(items, {
        opacity: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: items[0],
          start: 'top 88%',
          once: true
        }
      });
    }
  }

  function initModes(root, gsap, ScrollTrigger) {
    var modes = root.querySelectorAll('[data-mode-card]');
    if (!modes.length) return;
    gsap.to(modes, {
      opacity: 1,
      y: 0,
      duration: 0.7,
      stagger: 0.12,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: modes[0],
        start: 'top 88%',
        once: true
      }
    });
  }

  function initModelScroll(root, gsap, ScrollTrigger) {
    var mv = root.querySelector('model-viewer');
    var hero = root.querySelector('[data-indulge-hero]');
    if (!mv || !hero) return;
    if (hero.getAttribute('data-model-scroll') === 'false') return;

    var cta = root.querySelector('.indulge__hero-buy .indulge__submit');

    function begin() {
      mv.removeAttribute('auto-rotate');

      var orbit = { theta: -25, phi: 82, radius: 118 };
      try {
        var start = mv.getCameraOrbit();
        orbit.theta = start.theta * 180 / Math.PI;
        orbit.phi = start.phi * 180 / Math.PI;
      } catch (e) {}

      function write() {
        mv.cameraOrbit =
          orbit.theta.toFixed(2) + 'deg ' + orbit.phi.toFixed(2) + 'deg ' + orbit.radius.toFixed(1) + '%';
      }
      write();

      var flashed = false;
      gsap.to(orbit, {
        theta: orbit.theta + 290,
        phi: 64,
        radius: 96,
        ease: 'none',
        scrollTrigger: {
          trigger: hero,
          start: 'top top',
          end: 'bottom top',
          scrub: 0.5,
          onUpdate: function (self) {
            write();
            if (cta && !flashed && self.progress > 0.88) {
              flashed = true;
              cta.classList.add('is-flash');
              setTimeout(function () {
                cta.classList.remove('is-flash');
              }, 1400);
            } else if (self.progress < 0.6) {
              flashed = false;
            }
          }
        }
      });

      ScrollTrigger.refresh();
    }

    if (mv.loaded) begin();
    else mv.addEventListener('load', begin, { once: true });
  }

  function initStickyBar(root) {
    var bar = root.querySelector('[data-indulge-sticky]');
    var hero = root.querySelector('[data-indulge-hero]');
    if (!bar || !hero) return;
    var trustSection = root.querySelector('[data-sticky-hide-at]');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === hero) {
            bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(hero);

    if (trustSection) {
      var endObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) bar.classList.remove('is-visible');
          });
        },
        { threshold: 0 }
      );
      endObserver.observe(trustSection);
    }
  }

  /* ---------------------------------------------------------------------------
   * Unboxing reveal (Spline)
   *
   * The Spline scene ships its own "scroll to unbox" script inside a sandboxed
   * <iframe> that <spline-viewer> stacks over the canvas. As authored, that script
   * owns the input: every wheel / touch gesture over the viewer is preventDefault()'d
   * and turned into reveal progress, and its inner scroller uses
   * `overscroll-behavior: contain`. Result: the page cannot scroll while the pointer
   * is over the scene, and it stays stuck even after the reveal has finished.
   *
   * We keep the animation but hand the input back to the page:
   *   1. installRevealHook() rewrites the iframe's srcdoc (see REVEAL_PATCHES) so the
   *      scene stops capturing wheel / touch / keys and instead takes its progress
   *      from the host page.
   *   2. initReveal() pins the viewer inside a sticky track and posts the page's scroll
   *      progress through that track to the iframe. Native scrolling does the rest.
   *   3. The reveal responds from the first scroll: the scene's timeline is idle for its
   *      first ~20%, so progress is mapped past that (REVEAL_INPUT_JS). The stage locks in place
   *      just below the sticky header (CSS: top = --header-height), so nothing in the scene sits
   *      behind the header, and the reveal starts exactly at that moment (REVEAL_LEAD_IN = 0).
   *   4. The scene loads early (loadSceneEarly): <spline-viewer> would otherwise wait until it
   *      is on screen, which on a page where the reveal sits below the fold means the download
   *      and the scene build only start once the visitor scrolls there.
   *
   * Safety net: the iframe is click-through (pointer-events: none) until it confirms
   * it is running the patched script. If the scene is ever re-exported and the script
   * changes shape, the patches don't apply, the handshake never happens, and the page
   * simply stays scrollable instead of getting trapped again.
   * ------------------------------------------------------------------------- */
  var REVEAL_MARKER = '__splineHtmlContent';
  var REVEAL_MSG = '__indulgeReveal';
  var REVEAL_LEAD_IN = 0; // fraction of the stage height BEFORE it locks in place at which the reveal starts (0 = exactly when it locks in)
  var REVEAL_PATCHED = '__indulgeDriven'; // only present in a script we have already patched

  // Runs inside the scene's iframe (spliced into its async IIFE, so `target`, `clamp`,
  // `wake` and `buildTracks` are in scope).
  //
  // The authored timeline sits still until its earliest keyframe (the first ~20%): the lid
  // doesn't move at all until then. Mapped 1:1 to scroll, that is a couple of flicks where
  // nothing happens. So the host's 0..1 progress is mapped onto [first keyframe .. 1] instead,
  // and the very first scroll already starts opening the box. The earliest keyframe is read
  // from the scene itself, so it keeps working if the scene is retimed.
  var REVEAL_INPUT_JS = [
    '',
    "  // [indulge] reveal progress comes from the host page's pinned scroll track, not from wheel/touch on this frame",
    '  var indulgeLead = (function () {',
    '    try {',
    '      var tr = buildTracks(false), first = 1;',
    '      Object.keys(tr).forEach(function (k) { var a = tr[k]; if (a && a[0] && a[0].t < first) first = a[0].t; });',
    '      return first > 0 && first < 0.5 ? first : 0;',
    '    } catch (err) { return 0; }',
    '  })();',
    '  window.__indulgeLead = indulgeLead;',
    "  window.addEventListener('message', function (ev) {",
    '    if (ev.source !== window.parent) return;',
    '    var d = ev.data;',
    "    if (!d || d." + REVEAL_MSG + " !== true || typeof d.progress !== 'number') return;",
    '    window.__indulgeDriven = true;',
    '    target = clamp(indulgeLead + clamp(d.progress) * (1 - indulgeLead));',
    '    wake();',
    '  });',
    "  try { window.parent.postMessage({ " + REVEAL_MSG + ": 'ready' }, '*'); } catch (err) {}"
  ].join('\n');

  // Every required patch must match the scene's script exactly once, otherwise none are applied. Patches marked
  // `optional` are speed-ups only: if one doesn't match (the scene was re-exported) it is skipped on its own and the
  // rest still apply.
  var REVEAL_PATCHES = [
    {
      // The inner scroller must not trap scroll chaining.
      name: 'scroller css',
      find: /overflow:\s*auto;\s*overscroll-behavior:\s*contain;/,
      replace: function () { return 'overflow: hidden; overscroll-behavior: auto;'; }
    },
    {
      // Wheel over the frame must scroll the page, not preventDefault() and seek.
      name: 'wheel handler',
      find: /scroller\.addEventListener\(\s*'wheel'\s*,\s*e\s*=>\s*\{[\s\S]*?\}\s*,\s*\{\s*passive:\s*false\s*\}\s*\)\s*;/,
      replace: function () { return ''; }
    },
    {
      // Arrow / Page / Home / End / Space must keep scrolling the page.
      name: 'key handler',
      find: /if\s*\(\s*!\[\s*'ArrowDown'[^\]]*\]\s*\.includes\(\s*k\s*\)\s*\)\s*return\s*;/,
      replace: function () { return 'return;'; }
    },
    {
      // The scene's own page-scroll fallback poll reads a 0-6000px page range; once the
      // host drives progress it must stand down or it would yank the reveal back.
      name: 'fallback poller',
      find: /if\s*\(\s*pollBusy\s*\|\|/,
      replace: function () { return 'if (window.__indulgeDriven || pollBusy ||'; }
    },
    {
      name: 'progress input',
      find: /window\.addEventListener\(\s*'resize'\s*,\s*\(\)\s*=>\s*\{\s*scroller\.scrollTop\s*=\s*target\s*\*\s*maxScroll\(\)\s*;\s*wake\(\)\s*;\s*\}\s*\)\s*;/,
      replace: function (match) { return match + REVEAL_INPUT_JS; }
    },
    {
      // Startup speed-up. The scene looks up its 25 named objects one at a time, each a round trip to the page that
      // takes ~100+ ms while the page is busy: ~3 s before the reveal can respond. Ask for all of them at once (~30 ms).
      name: 'object lookups in parallel',
      optional: true,
      find: /for\s*\(\s*const\s+name\s+of\s+names\s*\)\s*\{\s*const\s+o\s*=\s*await\s+spline\.findObjectByName\(\s*name\s*\)\s*;\s*if\s*\(\s*!o\s*\)\s*\{\s*console\.error\(\s*'Missing reveal object: '\s*\+\s*name\s*\)\s*;\s*return\s*;\s*\}\s*objects\[name\]\s*=\s*o\s*;\s*\}/,
      replace: function () {
        return [
          'const __indulgeFound = await Promise.all(names.map(function (n) { return spline.findObjectByName(n); }));',
          '  for (let i = 0; i < names.length; i++) {',
          '    const o = __indulgeFound[i];',
          "    if (!o) { console.error('Missing reveal object: ' + names[i]); return; }",
          '    objects[names[i]] = o;',
          '  }'
        ].join('\n');
      }
    },
    {
      // Startup speed-up. The scene's page waits for the Google Fonts stylesheet before its script may run (a delay of
      // 0.4 s to several seconds on slow links), but the only text that uses those fonts appears late in the reveal and
      // already uses font-display: swap. Load the stylesheet without blocking.
      name: 'non-blocking fonts',
      optional: true,
      find: /<link href="(https:\/\/fonts\.googleapis\.com\/css2\?[^"]*)" rel="stylesheet" \/>/,
      replace: function (match, href) { return '<link href="' + href + '" rel="stylesheet" media="print" onload="this.media=\'all\'" />'; }
    },
    {
      // Layout fix for short stages. The scene's closing headline ("Indulge IPL" + tagline) is sized by the screen WIDTH
      // (up to 78px) and starts 9% down the stage, but the device finishes the reveal with its top about 23% down the
      // stage. On any stage shorter than ~950px (every laptop, most desktop browser windows) the tagline therefore ends
      // up underneath the device. Size the block by the stage HEIGHT as well and start it higher: wide screens only,
      // phones (<= 600px wide) already stack the headline and are untouched. Cosmetic, so it is skipped if the scene's
      // stylesheet changes shape.
      name: 'headline fits short stages',
      optional: true,
      find: /<\/style>\s*<\/head>/,
      replace: function (match) {
        return [
          '  /* [indulge] keep the closing headline clear of the device on short stages */',
          '  @media (min-width: 601px) {',
          '    #revealCopy { top: 4vh; }',
          '    #revealCopy h1 { font-size: min(clamp(30px, 6.2vw, 78px), 8.2vh); }',
          '    #revealCopy p { margin-top: 8px; }',
          '  }',
          ''
        ].join('\n') + match;
      }
    }
  ];

  function patchRevealHtml(html) {
    if (html.indexOf(REVEAL_PATCHED) !== -1) return { ok: true, html: html }; // already ours
    var out = html;
    for (var i = 0; i < REVEAL_PATCHES.length; i++) {
      var patch = REVEAL_PATCHES[i];
      var hits = out.match(new RegExp(patch.find.source, 'g'));
      if (!hits || hits.length !== 1) {
        if (patch.optional) continue;
        return { ok: false, html: html, failed: patch.name };
      }
      out = out.replace(patch.find, patch.replace);
    }
    return { ok: true, html: out };
  }

  // <spline-viewer> builds the overlay with `iframe.srcdoc = html`, so intercepting the
  // setter lets us patch the scene's script before the frame ever loads (no double load).
  function installRevealHook() {
    if (installRevealHook.done) return;
    installRevealHook.done = true;
    var proto = window.HTMLIFrameElement && window.HTMLIFrameElement.prototype;
    var desc = proto && Object.getOwnPropertyDescriptor(proto, 'srcdoc');
    if (!desc || typeof desc.set !== 'function' || !desc.configurable) return;
    Object.defineProperty(proto, 'srcdoc', {
      configurable: true,
      enumerable: desc.enumerable,
      get: desc.get,
      set: function (value) {
        var next = value;
        if (typeof value === 'string' && value.indexOf(REVEAL_MARKER) !== -1 && value.indexOf('id="revealScroll"') !== -1) {
          try {
            var result = patchRevealHtml(value);
            if (result.ok) {
              next = result.html;
            } else if (window.console && console.warn) {
              console.warn('[indulge] Spline reveal script changed shape (' + result.failed + ' patch); leaving the scene click-through so the page stays scrollable.');
            }
          } catch (err) {}
        }
        desc.set.call(this, next);
      }
    });
  }

  // <spline-viewer> only downloads its scene once it is on screen (loading="auto"), so a reveal that sits below the
  // fold would not start loading until the visitor scrolls to it. Ask for it right away instead, so that on a good
  // connection it is ready by the time the visitor gets there. The markup sets loading="eager" already; doing it here
  // as well keeps early loading working if the embed code is ever re-pasted without it. load() does nothing when the
  // scene is already loading or loaded, so this is safe to run on top of the attribute.
  function loadSceneEarly(viewer) {
    if (viewer.getAttribute('loading') !== 'eager') viewer.setAttribute('loading', 'eager');
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('spline-viewer').then(function () {
      var go = function () {
        try { if (typeof viewer.load === 'function') viewer.load(); } catch (err) {}
      };
      if (viewer.updateComplete && viewer.updateComplete.then) viewer.updateComplete.then(go, go);
      else go();
    });
  }

  function initReveal(root) {
    var track = root.querySelector('[data-indulge-reveal]');
    var sticky = track && track.querySelector('.indulge__reveal-sticky');
    var viewer = track && track.querySelector('spline-viewer');
    if (!sticky || !viewer) return;
    loadSceneEarly(viewer);
    if (root.__indulgeRevealCleanup) root.__indulgeRevealCleanup();

    var frame = null;
    var live = false; // the iframe has confirmed it runs the patched script
    var lastSent = -1;
    var raf = 0;
    var observer = null;

    // 0 when the stage locks in place, 1 when it lets go; linear in between. The stage locks in just below the sticky
    // header, so its CSS `top` is the header's height: read it every time, it follows the screen size (64 / 70 / 86px).
    function progress() {
      var stage = sticky.offsetHeight;
      var pin = track.offsetHeight - stage;
      if (pin < 1) return 0;
      var y = window.pageYOffset;
      var top = parseFloat(window.getComputedStyle(sticky).top) || 0;
      var pinAt = track.getBoundingClientRect().top + y - top; // scroll position where the stage locks in place
      var start = Math.max(0, pinAt - REVEAL_LEAD_IN * stage);
      var span = pinAt + pin - start;
      if (span < 1) return 0;
      var p = (y - start) / span;
      return p < 0 ? 0 : p > 1 ? 1 : p;
    }

    function flush(force) {
      raf = 0;
      var p = progress();
      if (!force && Math.abs(p - lastSent) < 0.0005) return;
      lastSent = p;
      if (!live || !frame || !frame.contentWindow) return;
      var msg = { progress: p };
      msg[REVEAL_MSG] = true;
      try { frame.contentWindow.postMessage(msg, '*'); } catch (err) {}
    }

    function schedule() {
      if (!raf) raf = window.requestAnimationFrame(function () { flush(false); });
    }

    function onResize() {
      schedule();
    }

    // <spline-viewer> can build its overlay before this script has run (scene already cached, slow page parse),
    // in which case the srcdoc hook never saw it. Patch the frame we find instead; assigning srcdoc reloads it.
    function ensurePatched(f) {
      var html = f && f.getAttribute('srcdoc');
      if (!html || html.indexOf(REVEAL_MARKER) === -1 || html.indexOf('id="revealScroll"') === -1) return;
      if (html.indexOf(REVEAL_PATCHED) !== -1) return;
      var result = patchRevealHtml(html);
      if (result.ok) f.srcdoc = result.html;
      else if (window.console && console.warn) console.warn('[indulge] Spline reveal script changed shape (' + result.failed + ' patch); leaving the scene click-through so the page stays scrollable.');
    }

    function bind(next) {
      if (next === frame) return;
      frame = next;
      live = false;
      lastSent = -1;
      // Not interactive until it proves it runs the patched script.
      if (frame) {
        frame.style.setProperty('pointer-events', 'none', 'important');
        try { ensurePatched(frame); } catch (err) {}
      }
    }

    function onMessage(ev) {
      if (!frame || ev.source !== frame.contentWindow) return;
      var d = ev.data;
      if (!d || d[REVEAL_MSG] !== 'ready') return;
      live = true;
      frame.style.setProperty('pointer-events', 'auto'); // head hotspots (hover / tap) keep working
      flush(true);
    }

    function watch() {
      var shadow = viewer.shadowRoot;
      if (!shadow) return;
      bind(shadow.querySelector('iframe'));
      observer = new MutationObserver(function () {
        bind(shadow.querySelector('iframe'));
      });
      observer.observe(shadow, { childList: true, subtree: true });
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('message', onMessage);
    if (viewer.shadowRoot) watch();
    else if (window.customElements && customElements.whenDefined) customElements.whenDefined('spline-viewer').then(watch);

    root.__indulgeRevealCleanup = function () {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('message', onMessage);
      if (observer) observer.disconnect();
      if (raf) window.cancelAnimationFrame(raf);
      root.__indulgeRevealCleanup = null;
    };
  }

  function staticFallback(root) {
    root.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('is-in');
    });
    root.querySelectorAll('[data-stat-value]').forEach(function (el) {
      el.textContent = el.getAttribute('data-stat-value');
    });
  }

  function init(root) {
    initStickyBar(root);
    // Scroll-linked, not autoplay: keep it working under prefers-reduced-motion and without GSAP.
    // Not on devices the 3D gate (sections/indulge-product.liquid) has ruled out: the viewer is never loaded there. The gate may
    // still be testing the device at this point; if it rules the device out later it calls root.__indulgeRevealCleanup().
    if (!root.classList.contains('is-lite')) initReveal(root);

    if (reduceMotion) {
      staticFallback(root);
      return;
    }

    loadGsap()
      .then(function () {
        var gsap = window.gsap;
        var ScrollTrigger = window.ScrollTrigger;
        gsap.registerPlugin(ScrollTrigger);
        root.classList.add('indulge--js');

        initReveals(root, gsap, ScrollTrigger);
        initStats(root, gsap, ScrollTrigger);
        initUnbox(root, gsap, ScrollTrigger);
        initModes(root, gsap, ScrollTrigger);

        var hero = root.querySelector('[data-indulge-hero]');
        var heroMode = hero && hero.getAttribute('data-hero-mode');
        if (heroMode === 'spin') {
          initSpin(root, gsap, ScrollTrigger);
        } else if (heroMode === 'parallax') {
          initHeroParallax(root, gsap, ScrollTrigger);
        } else if (heroMode === '3d') {
          initModelScroll(root, gsap, ScrollTrigger);
        }
      })
      .catch(function () {
        staticFallback(root);
      });
  }

  function boot() {
    document.querySelectorAll('[data-indulge-root]').forEach(init);
  }

  // Must be in place before <spline-viewer> mounts its HTML overlay (it does so after the scene downloads).
  installRevealHook();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-indulge-root]') : null;
    if (root) init(root);
  });
})();
